var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "main-content" }, [
      _c("div", { staticClass: "main-content-inner" }, [
        _c(
          "div",
          {
            staticClass: "breadcrumbs ace-save-state",
            attrs: { id: "breadcrumbs" }
          },
          [
            _c(
              "ul",
              { staticClass: "breadcrumb" },
              [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "router-link",
                  { attrs: { tag: "li", to: { name: "group" } } },
                  [_c("a", [_vm._v("ゲートグループ一覧 ")])]
                ),
                _vm._v(" "),
                _c("li", { staticClass: "active" }, [
                  _vm._v("新規ゲートグループ登録")
                ])
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "page-content" }, [
          _vm.loading
            ? _c("div", { attrs: { id: "loading" } }, [
                _c("div", { staticClass: "loadingMsg" })
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "tab-content" }, [
            _vm.message_success
              ? _c("div", { staticClass: "alert alert-success" }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.message_success) + "\n        "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.message_error
              ? _c("div", { staticClass: "alert alert-danger" }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.message_error) + "\n        "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-xs-12" }, [
                _c(
                  "form",
                  { staticClass: "form-horizontal", attrs: { role: "form" } },
                  [
                    _c("div", { staticClass: "form-group" }, [
                      _vm._m(2),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass:
                            "col-sm-2 control-label no-padding-right",
                          attrs: { for: "form-field-1" }
                        },
                        [
                          _vm._v("ゲートグループ名 "),
                          _c("font", { staticClass: "input-required" }, [
                            _vm._v("※必須")
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-10" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.groupInfor.name,
                              expression: "groupInfor.name"
                            }
                          ],
                          staticClass: "form-control input-sm",
                          attrs: {
                            type: "text",
                            id: "name",
                            placeholder: "ゲートグループ名"
                          },
                          domProps: { value: _vm.groupInfor.name },
                          on: {
                            blur: _vm.validateBeforeSubmit,
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.groupInfor,
                                "name",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "label",
                        {
                          staticClass:
                            "col-sm-2 control-label no-padding-right",
                          attrs: { for: "form-field-1" }
                        },
                        [_vm._v("ステータス")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-1" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.groupInfor.isValid,
                              expression: "groupInfor.isValid"
                            }
                          ],
                          staticClass: "ace ace-switch ace-switch-4",
                          attrs: { name: "switch-field-1", type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(_vm.groupInfor.isValid)
                              ? _vm._i(_vm.groupInfor.isValid, null) > -1
                              : _vm.groupInfor.isValid
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.groupInfor.isValid,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.groupInfor.isValid = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.groupInfor.isValid = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.$set(_vm.groupInfor, "isValid", $$c)
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "lbl" })
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", {
                        staticClass: "col-sm-2 control-label no-padding-right",
                        attrs: { for: "form-field-1" }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-sm-10" },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "btn cancel_bottom",
                              attrs: { to: { name: "group" } }
                            },
                            [
                              _vm._v(
                                "\n                  キャンセル\n                "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-info save_group_bottom",
                              attrs: { type: "button" },
                              on: { click: _vm.addGroup }
                            },
                            [
                              _vm._v(
                                "\n                  保存\n                "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ])
                  ]
                )
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("i", { staticClass: "ace-icon fa fa-home home-icon" }),
      _vm._v(" "),
      _c("a", { attrs: { href: "#/" } }, [_vm._v("メインメニュー")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header" }, [
      _c("div", { staticClass: "checkbox" }, [
        _c("h3", [_vm._v("新規ゲートグループ登録")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-offset-2 col-md-10" }, [
      _c("span", { staticClass: "error_m", attrs: { id: "name_error" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a69a6228", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a69a6228","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/group/GroupAdd.vue
// module id = null
// module chunks = 